module.exports = __webpack_public_path__ + "img/di13.ab26d606.png";